// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.struct-explorer {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;

    width: min-content;
    z-index: 10;

    background: #2d2d2dcc;

    .struct-explorer-top {
        display: flex;
        flex-direction: row;
        min-width: 0;

        label {
            white-space: nowrap;
            width: 0;
            input {
                margin: 0;
            }
            span {
                width: 100vw;
                display: inline-block;
            }
        }
    }

    .struct-root-node {
        overflow: hidden;
        flex: 0 1 50%;
        max-height: max-content;

        box-shadow: inset white 0 0 5px;

        .struct-list {
            display: grid;
            grid-template-columns: repeat(4, auto);
            align-items: start;
            align-content: flex-start;

            padding: 0;
            height: 100%;
            overflow: auto;
            border: 1px solid black;
            box-shadow: 0 0 0.5em #999;
            scrollbar-color: hsla(24, 20%, 50%,.4) #2d2d2d;

            font-size: 0.8em;
            color: #eee;

            & :is(a, a:visited) {
                color: inherit;
            }

            .struct-entry {
                display: grid;
                grid-template-columns: auto 1fr;
                grid-column: 1 / 5;

                column-gap: 1ex;
                margin: 20px 0 0 0;
                padding: 1ex;

                box-shadow: 0 0 0.5em #999;
                background: hsla(24, 20%, 50%,.4);

                & input {
                    visibility: hidden;
                    position: absolute;
                }
                &:not(:has(:checked)) + .struct-alloc {
                    visibility: hidden;
                    height: 0;
                }
            }
            .struct-alloc {
                display: grid;
                grid-column: 1 / 5;
                grid-template-columns: subgrid;

                & > * {
                    padding: 1ex;
                    border-bottom: 1px dashed #ccc;
                }
                .struct-alloc-cache {
                    margin-left: 3em;
                    white-space: nowrap;
                }
                .struct-alloc-call {
                    text-align: end;
                }
                .struct-alloc-metadata {
                    white-space: nowrap;
                }
            }
        }
    }
    & .field-explorer {
        display: flex;
        flex-direction: row;
        flex: 1 1 50%;
        max-height: max-content;
        overflow: hidden;
        background: hsla(24, 20%, 50%,.4);
        a {
            color: inherit;
        }
        .fields-root-node {
            flex: 0 1 50%;
            min-width: min-content;
            max-width: max-content;
            overflow-y: auto;
            overflow-x: hidden;
            scrollbar-color: #bbb #2d2d2d;
            max-height: 100%;
            font-size: 0.8em;
            background: #2d2d2d88;
            padding: 0;
            white-space: nowrap;
            box-shadow: inset white 0 0 5px;
            border-radius: 5px;
            & > .tree-leaf > .tree-leaf-content {
                font-weight: bold;
                background: black;
                position: sticky;
                top: 0;
                z-index: 1;
            }
            .tree-leaf-content {
                overflow-y: scroll;
                scrollbar-width: none;
                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }
        .access-root-node {
            flex: 1 1 100%;
            &:not(:empty) {
                overflow-y: scroll;
            }
            scrollbar-color: #bbb transparent;
            .access-list {
                display: grid;
                grid-template-columns: auto 1fr auto;
                white-space: nowrap;
                font-size: 0.8em;
                .access-field {
                    display: grid;
                    grid-column: 1/4;
                    grid-template-columns: subgrid;

                    background: #2d2d2d88;
                    padding-top: 10px;
                }
                .access-calls {
                    display: grid;
                    grid-column: 1/4;
                    grid-template-columns: subgrid;

                    background: hsla(24, 20%, 50%,.4);
                    .access-call-type {
                        margin-left: auto;
                    }
                }
            }
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/views/struct/struct.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;;IAEX,kBAAkB;IAClB,WAAW;;IAEX,qBAAqB;;IAErB;QACI,aAAa;QACb,mBAAmB;QACnB,YAAY;;QAEZ;YACI,mBAAmB;YACnB,QAAQ;YACR;gBACI,SAAS;YACb;YACA;gBACI,YAAY;gBACZ,qBAAqB;YACzB;QACJ;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,uBAAuB;;QAEvB,+BAA+B;;QAE/B;YACI,aAAa;YACb,sCAAsC;YACtC,kBAAkB;YAClB,yBAAyB;;YAEzB,UAAU;YACV,YAAY;YACZ,cAAc;YACd,uBAAuB;YACvB,0BAA0B;YAC1B,8CAA8C;;YAE9C,gBAAgB;YAChB,WAAW;;YAEX;gBACI,cAAc;YAClB;;YAEA;gBACI,aAAa;gBACb,+BAA+B;gBAC/B,kBAAkB;;gBAElB,eAAe;gBACf,kBAAkB;gBAClB,YAAY;;gBAEZ,0BAA0B;gBAC1B,iCAAiC;;gBAEjC;oBACI,kBAAkB;oBAClB,kBAAkB;gBACtB;gBACA;oBACI,kBAAkB;oBAClB,SAAS;gBACb;YACJ;YACA;gBACI,aAAa;gBACb,kBAAkB;gBAClB,8BAA8B;;gBAE9B;oBACI,YAAY;oBACZ,8BAA8B;gBAClC;gBACA;oBACI,gBAAgB;oBAChB,mBAAmB;gBACvB;gBACA;oBACI,eAAe;gBACnB;gBACA;oBACI,mBAAmB;gBACvB;YACJ;QACJ;IACJ;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,iCAAiC;QACjC;YACI,cAAc;QAClB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,sBAAsB;YACtB,gBAAgB;YAChB,kBAAkB;YAClB,6BAA6B;YAC7B,gBAAgB;YAChB,gBAAgB;YAChB,qBAAqB;YACrB,UAAU;YACV,mBAAmB;YACnB,+BAA+B;YAC/B,kBAAkB;YAClB;gBACI,iBAAiB;gBACjB,iBAAiB;gBACjB,gBAAgB;gBAChB,MAAM;gBACN,UAAU;YACd;YACA;gBACI,kBAAkB;gBAClB,qBAAqB;gBACrB;oBACI,aAAa;gBACjB;YACJ;QACJ;QACA;YACI,cAAc;YACd;gBACI,kBAAkB;YACtB;YACA,iCAAiC;YACjC;gBACI,aAAa;gBACb,oCAAoC;gBACpC,mBAAmB;gBACnB,gBAAgB;gBAChB;oBACI,aAAa;oBACb,gBAAgB;oBAChB,8BAA8B;;oBAE9B,qBAAqB;oBACrB,iBAAiB;gBACrB;gBACA;oBACI,aAAa;oBACb,gBAAgB;oBAChB,8BAA8B;;oBAE9B,iCAAiC;oBACjC;wBACI,iBAAiB;oBACrB;gBACJ;YACJ;QACJ;IACJ;AACJ","sourcesContent":[".struct-explorer {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 0;\n\n    width: min-content;\n    z-index: 10;\n\n    background: #2d2d2dcc;\n\n    .struct-explorer-top {\n        display: flex;\n        flex-direction: row;\n        min-width: 0;\n\n        label {\n            white-space: nowrap;\n            width: 0;\n            input {\n                margin: 0;\n            }\n            span {\n                width: 100vw;\n                display: inline-block;\n            }\n        }\n    }\n\n    .struct-root-node {\n        overflow: hidden;\n        flex: 0 1 50%;\n        max-height: max-content;\n\n        box-shadow: inset white 0 0 5px;\n\n        .struct-list {\n            display: grid;\n            grid-template-columns: repeat(4, auto);\n            align-items: start;\n            align-content: flex-start;\n\n            padding: 0;\n            height: 100%;\n            overflow: auto;\n            border: 1px solid black;\n            box-shadow: 0 0 0.5em #999;\n            scrollbar-color: hsla(24, 20%, 50%,.4) #2d2d2d;\n\n            font-size: 0.8em;\n            color: #eee;\n\n            & :is(a, a:visited) {\n                color: inherit;\n            }\n\n            .struct-entry {\n                display: grid;\n                grid-template-columns: auto 1fr;\n                grid-column: 1 / 5;\n\n                column-gap: 1ex;\n                margin: 20px 0 0 0;\n                padding: 1ex;\n\n                box-shadow: 0 0 0.5em #999;\n                background: hsla(24, 20%, 50%,.4);\n\n                & input {\n                    visibility: hidden;\n                    position: absolute;\n                }\n                &:not(:has(:checked)) + .struct-alloc {\n                    visibility: hidden;\n                    height: 0;\n                }\n            }\n            .struct-alloc {\n                display: grid;\n                grid-column: 1 / 5;\n                grid-template-columns: subgrid;\n\n                & > * {\n                    padding: 1ex;\n                    border-bottom: 1px dashed #ccc;\n                }\n                .struct-alloc-cache {\n                    margin-left: 3em;\n                    white-space: nowrap;\n                }\n                .struct-alloc-call {\n                    text-align: end;\n                }\n                .struct-alloc-metadata {\n                    white-space: nowrap;\n                }\n            }\n        }\n    }\n    & .field-explorer {\n        display: flex;\n        flex-direction: row;\n        flex: 1 1 50%;\n        max-height: max-content;\n        overflow: hidden;\n        background: hsla(24, 20%, 50%,.4);\n        a {\n            color: inherit;\n        }\n        .fields-root-node {\n            flex: 0 1 50%;\n            min-width: min-content;\n            max-width: max-content;\n            overflow-y: auto;\n            overflow-x: hidden;\n            scrollbar-color: #bbb #2d2d2d;\n            max-height: 100%;\n            font-size: 0.8em;\n            background: #2d2d2d88;\n            padding: 0;\n            white-space: nowrap;\n            box-shadow: inset white 0 0 5px;\n            border-radius: 5px;\n            & > .tree-leaf > .tree-leaf-content {\n                font-weight: bold;\n                background: black;\n                position: sticky;\n                top: 0;\n                z-index: 1;\n            }\n            .tree-leaf-content {\n                overflow-y: scroll;\n                scrollbar-width: none;\n                &::-webkit-scrollbar {\n                    display: none;\n                }\n            }\n        }\n        .access-root-node {\n            flex: 1 1 100%;\n            &:not(:empty) {\n                overflow-y: scroll;\n            }\n            scrollbar-color: #bbb transparent;\n            .access-list {\n                display: grid;\n                grid-template-columns: auto 1fr auto;\n                white-space: nowrap;\n                font-size: 0.8em;\n                .access-field {\n                    display: grid;\n                    grid-column: 1/4;\n                    grid-template-columns: subgrid;\n\n                    background: #2d2d2d88;\n                    padding-top: 10px;\n                }\n                .access-calls {\n                    display: grid;\n                    grid-column: 1/4;\n                    grid-template-columns: subgrid;\n\n                    background: hsla(24, 20%, 50%,.4);\n                    .access-call-type {\n                        margin-left: auto;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
